module.exports = __webpack_public_path__ + "static/media/class (13).3d433f93.webp";